<!-- 学员详情 -->
<template> 
  <div>
    <div class="home">
      <div class="contLeft">
        <el-descriptions title="基本信息">
          <el-descriptions-item label="真实姓名">{{ studentsInfo.realname }}</el-descriptions-item>
          <el-descriptions-item label="手机号">{{ studentsInfo.mobile }}</el-descriptions-item>
          <el-descriptions-item label="创建人">{{ studentsInfo.add_tob_user_name }}</el-descriptions-item>
          <el-descriptions-item label="添加方式">{{ studentsInfo.add_type_name }}</el-descriptions-item>
          <el-descriptions-item label="登录帐号">{{ studentsInfo.username }}</el-descriptions-item>
          <el-descriptions-item label="最近登录">{{ studentsInfo.last_login }}</el-descriptions-item>
          <el-descriptions-item label="创建时间">{{ studentsInfo.created_at }}</el-descriptions-item>
          <el-descriptions-item v-if="studentsInfo && studentsInfo.teacher_list && studentsInfo.teacher_list.length > 0" label="关联老师">
            <span v-for="(item, index) in studentsInfo.teacher_list" :key="index">
              <span v-if="index != 0" style="padding: 0 5px;">/</span>
              {{ item.realname }}
            </span>
          </el-descriptions-item> 
        </el-descriptions>
      </div>
      <div class="contRight">
        <h4 style="margin-bottom: 20px;">商品信息</h4>
        <el-row v-for="(item, index) in studentsInfo.open_good_list" :key="index">
          <el-col :span="12">
            {{ item.good_name }} （ID：{{ item.good_id }}）
          </el-col>
          <el-col :span="12">
            <div v-if="item.order_status == 1">
              <p>支付时间：{{ item.pay_at }}</p>
              <p>到期时间：{{ item.due_time }} <span v-if="item.is_due">（已到期）</span></p>  
            </div>
            <div v-else>
              已开通未激活
            </div> 
          </el-col>
        </el-row> 
      </div> 
    </div> 
    <div class="home">
      <el-tabs v-model="activeName" @tab-click="handleClick(activeName)" style="width: 100%;padding: 20px;background-color: #fff;">
        <el-tab-pane
          :key="item.name"
          v-for="item in data_type_list"
          :label="item.name"
          :name="'name_' + item.id"
        > 
          <div v-if="activeName == 'name_1'"> 
            <div class="tongjiBox">
              <div class="tongjiItem">
                <div class="title">总刷题时长</div>
                <div class="num">{{ tongjiData.zt_time }}</div>
              </div>
              <div class="tongjiItem">
                <div class="title">总答题数</div>
                <div class="num">{{ tongjiData.answer_num }}道</div>
              </div>
              <div class="tongjiItem">
                <div class="title">总正确率</div>
                <div class="num">{{ tongjiData.right_percent }}</div>
              </div>
              <div class="tongjiItem">
                <div class="title">总看视频时长</div>
                <div class="num">{{ tongjiData.video_time }}
                  <span v-if="tongjiData.video_time > 0">课时</span>  
                </div>
              </div>
            </div>
            <div class="subjectBox">
              科目： 
              <el-select
                v-model="subject_ids"
                filterable
                placeholder="" 
                size="mini"
                @change="subjectChange"
              >
                <el-option
                  v-for="item in subjectAllOptions"
                  :key="item.subject_id"
                  :label="item.subject_name"
                  :value="item.subject_id"
                >
                </el-option>
              </el-select> 
            </div>
            <div class="trendBox">
              <div class="title"> 
                趋势
              </div>
              <div class="cont">  
                <div class="radioBox">
                  <el-radio-group
                    v-model="trendType"
                    class="order-type-box"  
                    @change="trendTypeChange"
                  >
                    <el-radio-button 
                      class="order-type-item" 
                      label="1"
                      >正确率</el-radio-button
                    >
                    <el-radio-button
                      class="order-type-item"
                      label="2" 
                      >答题数</el-radio-button
                    >
                    <el-radio-button 
                      class="order-type-item"
                      label="3"
                      >考试得分</el-radio-button
                    >
                  </el-radio-group>
 
                  <el-radio-group
                    v-model="timeType"
                    class="order-type-box" 
                    style="margin-left: 120px;"
                    @change="timeTypeChange"
                  >
                    <el-radio 
                      class="order-type-item" 
                      label="1"
                      >近7天</el-radio
                    >
                    <el-radio
                      class="order-type-item"
                      label="2" 
                      >近8周</el-radio
                    > 
                  </el-radio-group>
                </div> 
              </div>  
              <div class="chart_wrap">
                <div id="myChart" class="broken_chart"></div> 
              </div>
            </div>
          </div>
          <div v-if="activeName == 'name_2'">
            <div style="padding-bottom: 20px;display: flex;">
              <el-radio-group
                v-model="orderType"
                class="order-type-box"
                @input="orderTypeChange"
              >
                <el-radio-button class="order-type-item" label="1"
                  >机构开通订单</el-radio-button
                >
                <!-- <el-radio-button
                  class="order-type-item"
                  label="2"
                  v-if="role == 'admin'"
                  >学员自购订单（推广订单）</el-radio-button
                > -->
                <el-radio-button
                  v-if="is_study_card"
                  class="order-type-item"
                  label="3"
                  >卡密订单</el-radio-button
                >
              </el-radio-group>
 
              <div class="payStatusBox" style="margin-left: 40px;">
                <span style="display: inline-block; ">订单状态：</span>
                <el-select
                  v-if="orderType == 1"
                  v-model="queryInfo.pay_status"
                  size="small"
                  class="w100Select"
                  @change="payStatusChange"
                >
                  <el-option label="全部" :value="-1"></el-option>
                  <el-option label="已取消" :value="2"></el-option>
                  <el-option label="已开通" :value="0"></el-option>
                  <el-option label="已扣款" :value="1"></el-option>
                  <el-option label="已退款" :value="3"></el-option>
                </el-select>
                <el-select
                  v-else-if="orderType == 2"
                  v-model="queryInfo.pay_status"
                  size="small"
                  class="w100Select"
                  @change="payStatusChange"
                >
                  <el-option label="全部" :value="-1"></el-option>
                  <el-option label="已取消" :value="2"></el-option>
                  <el-option label="已退款" :value="3"></el-option>
                  <el-option label="未支付" :value="6"></el-option>
                  <el-option label="已支付" :value="7"></el-option>
                </el-select>
                <el-select
                  v-else
                  v-model="queryInfo.pay_status"
                  size="small"
                  class="w100Select"
                  @change="payStatusChange"
                >
                  <el-option
                    v-for="item in order_status_list"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  />
                </el-select>
              </div>
              <div class="payStatusBox" style="margin-left: 40px;"> 
                <el-select
                  v-model="timeChange"
                  size="small"
                  class="w100Select"
                  @change="timeChangeClick"
                >
                  <el-option label="支付时间" :value="4"></el-option>
                  <el-option label="创建时间" :value="2"></el-option>
                </el-select> 
                <el-date-picker
                  v-model="timeFrame"
                  size="small"
                  type="datetimerange"
                  range-separator="至"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  :default-time="['00:00:00', '23:59:59']"
                  start-placeholder="开始日期"
                  @change="selectData"
                  end-placeholder="结束日期"
                  style="margin-left: 10px;"
                >
                </el-date-picker>  
              </div> 
            </div>
            <div class="table" v-loading="tableLoading">
              <TableComponents
                v-if="orderType == 1"
                :columns="columns"
                :tableData="tableList"
                :tableFunction="tableFunction"
                :allSelectedStatus="allSelectedStatus"
                :allStatus="allStatus"
                :selectableShow = "selectableShow"
                @choiceGoods="choiceGoods" 
              >
                <template slot="good_name" slot-scope="{ row }">
                  {{ row.good_name }}
                  <span style="color: red;" v-if="row.upgrade_from_good_name">{{ row.upgrade_from_good_name}}</span>
                </template>
                <template slot="fees" slot-scope="{ row }">
                  {{ row.fees }}
                  <span v-if="row.give_fee">赠送金额抵扣{{ row.give_fee }}(元) </span>
                </template>
                <template slot="create_user" slot-scope="{ row }">
                  <div v-if="row.userext">
                    {{ row.userext.create_user }} 
                  </div>
                </template>
                <template slot="operation" slot-scope="{ row }">
                  <span class="operationItem" @click="viewDetail(row, 1)">查看详情</span>
                  <span v-if="row.is_upgrade == 1">已升级</span>
                  <span style="color: orange; cursor: pointer;" v-else-if="row.is_can_upgrade == 1" @click="upgradeOrder(row)">升级</span>
                </template>
              </TableComponents>
              <!-- <TableComponents
                v-if="orderType == 2"
                :columns="selfColumns"
                :tableData="tableList"
                :tableFunction="tableFunction"
                :allSelectedStatus="allSelectedStatus"
                :allStatus="allStatus"
                :selectableShow = "selectableShow"
                @choiceGoods="choiceGoods"
              >
                <template slot="fees" slot-scope="{ row }">
                  {{ row.fees }}
                  <span v-if="row.give_fee">赠送金额抵扣{{ row.give_fee }}(元) </span>
                </template>
                <template slot="operation" slot-scope="{ row }">
                  <span class="operationItem" @click="viewDetail(row, 1)"
                    >查看详情</span
                  >
                </template>
              </TableComponents> -->
              <TableComponents
                v-if="is_study_card && orderType == 3"
                :columns="kamilColumns"
                :tableData="tableList"
                :tableFunction="tableFunction"
                :allSelectedStatus="allSelectedStatus"
                :allStatus="allStatus"
                :selectableShow = "selectableShow"
                @choiceGoods="choiceGoods"
              >
                <template slot="fees" slot-scope="{ row }">
                  {{ row.fees }}
                  <span v-if="row.give_fee">赠送金额抵扣{{ row.give_fee }}(元) </span>
                </template>
                <template slot="operation" slot-scope="{ row }">
                  <span class="operationItem" @click="viewDetail(row, 1)"
                    >查看详情</span
                  >
                </template>
              </TableComponents>
            </div> 
            
            <div class="pagination">
              <el-pagination
                @size-change="handleSizeChange2"
                @current-change="handleCurrentChange2"
                :current-page="queryInfo.page"
                :page-sizes="[10, 30, 50, 80]"
                :page-size="queryInfo.limit"
                layout="total, sizes, prev, pager, next, jumper"
                :total="queryInfo.total"
              >
              </el-pagination>
            </div>
          </div>
          <div v-if="activeName == 'name_3'">
            <div class="table_box">
              <el-table :data="tableData" stripe style="width: 100%" border>
                <!-- <el-table-column prop="good_app_type_name" label="考试名称" align="center" /> -->
                <el-table-column prop="name" label="课程名称" align="center" />
                <el-table-column prop="start_study_time" label="开始学习时间" align="center" />
                <el-table-column prop="end_study_time" label="最后学习时间" align="center" /> 
                <el-table-column prop="chapter_study_num" label="已看课时数/总课时数" align="center">
                  <template slot-scope="scope">
                    {{ scope.row.chapter_study_num }}/{{ scope.row.chapter_total }} 
                  </template>
                </el-table-column>
                <el-table-column prop="total_study_duration" label="学习用时（小时）/总时长（小时）" align="center">
                  <template slot-scope="scope">
                    {{ scope.row.total_study_duration }}/{{ scope.row.total_video_duration }} 
                  </template>
                </el-table-column> 
                <el-table-column prop="progress_rate" label="学习进度比" align="center" />
              </el-table>
            </div>  
            <div class="page_box">
              <el-pagination
                :current-page="searchFormObj.page"
                background
                :page-sizes="[10, 20, 30, 50]"
                :page-size="searchFormObj.limit"
                layout="total, sizes, prev, pager, next, jumper"
                :total="total"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
              />
            </div>
          </div>
          <div v-if="activeName == 'name_4'">
            <div class="table_box">
              <el-table :data="tableData" stripe style="width: 100%" border>
                <!-- <el-table-column prop="good_app_type_name" label="考试名称" align="center" /> -->
                <el-table-column prop="subject_name" label="科目" align="center" />
                <el-table-column prop="answer_num" label="答题数" align="center" />
                <el-table-column prop="right_percent" label="正确率" align="center" />
                <el-table-column prop="exercise_time" label="累计时长（h)" align="center" />
                <el-table-column prop="learn_days" label="刷题天数" align="center" />
                <el-table-column prop="user_paper_max_score" label="考试最高分" align="center" />
                <el-table-column prop="user_paper_avg_score" label="考试平均分" align="center" />
                <el-table-column prop="user_paper_count" label="考试次数" align="center" />  
              </el-table>
            </div>  
            <div class="page_box">
              <el-pagination
                :current-page="searchFormObj.page"
                background
                :page-sizes="[10, 20, 30, 50]"
                :page-size="searchFormObj.limit"
                layout="total, sizes, prev, pager, next, jumper"
                :total="total"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
              />
            </div>
          </div>
          <div v-if="activeName == 'name_5'">
            <div class="table_box">
              <el-table :data="tableData" stripe style="width: 100%" border>
                <!-- <el-table-column prop="app_type_name" label="产品名称" align="center" /> -->
                <el-table-column prop="uid" label="用户id" align="center" />
                <el-table-column prop="subject_name" label="做题科目" align="center" />
                <el-table-column prop="paper_type_name" label="类型" align="center" /> 
                <el-table-column prop="paper_name" label="名称" align="center" />
                <el-table-column prop="answer_num" label="答题数量" align="center" />
                <el-table-column prop="status_name" label="状态" align="center" /> 
                <el-table-column prop="score" label="成绩" align="center" />
                <el-table-column prop="created_at" label="开始时间" align="center" />
                <el-table-column prop="updated_at" label="结束时间" align="center" />
              </el-table>
            </div>  
            <div class="page_box">
              <el-pagination
                :current-page="searchFormObj.page"
                background
                :page-sizes="[10, 20, 30, 50]"
                :page-size="searchFormObj.limit"
                layout="total, sizes, prev, pager, next, jumper"
                :total="total"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
              />
            </div>
          </div>
        </el-tab-pane> 
      </el-tabs>
    </div> 
  </div>
</template>

<script>
import commonApi from "@/api/common"; 
import goodsApi from "@/api/goods.js";
import financialApi from "@/api/financial.js";
import { clearObj, deepClone } from "@/utils/index.js";
import TableComponents from "@/components/TableComponents.vue";
import * as echarts from "echarts"; 
export default {
  name: "studentDetails", //学员详情
  components: {
    TableComponents, 
  },
  data() {
    return {  
      searchFormObj:{
        limit: 10,
        page: 1
      },
      total: 0,
      type: 1,
      studentsInfo: {}, 
      activeName: 'name_1',
      data_type_list: [],
      uid: '',  
      subject_ids: '',
      tableData: [], 
      orderType: 1, // 订单类型
      allStatus: false,
      allStatusText:"选择当前页",
      selectedList:[],
      queryInfo: {
        limit: 10,
        page: 1,
        total: 0,
        pay_status: -1,
        pm_user_id: "",
        order_no: "",
        user_no: "",
        good_type: "",
        good_name: "",
        created_start_time: "",
        created_end_time: "",
        pay_start_time: "",
        pay_end_time: "",
        card_status: 0, 
      },
      tableFunction: {
        checkData: 1, //是否允许勾选 
        name: "dialogGoods",
      },
      tableList: [],
      columns: [
        //列数据
        { label: "订单号", prop: "order_no" },
        { label: "学员账号", prop: "user_no" }, 
        { label: "学员姓名", prop: "realname" },
        { label: "学员手机号", prop: "mobile" }, 
        { label: "开通人（机构账号登录）", prop: "pm_user_id" },
        // {label:'商品类型',prop:'finTransaction'},
        { label: "商品类型", prop: "goods_type_name" },
        { label: "商品名称", prop: "good_name", isMyself: true },
        { label: "商品ID", prop: "good_id" },
        { label: "所属考试", prop: "subject_cate_name" },
        { label: "订单总价", prop: "fee" },
        { label: "实付价格", prop: "fees", isMyself: true },
        { label: "订单状态", prop: "payStatus" },
        { label: "支付方式", prop: "cooperation_type" },
        { label: "实际支付时间", prop: "pay_at" },
        { label: "订单创建时间", prop: "created_at" },
        { label: "学员所属创建人", prop: "create_user", isMyself: true },
        // { label: "操作", prop: "operation" },
      ],
      selfColumns: [
        //学员自购订单（推广订单）列数据
        { label: "订单号", prop: "order_no" },
        { label: "学员账号", prop: "user_no" },
        { label: "学员姓名", prop: "realname" },
        { label: "学员手机号", prop: "mobile" },
        { label: "商品类型", prop: "goods_type_name" },
        { label: "商品名称", prop: "good_name" },
        { label: "商品ID", prop: "good_id" },
        { label: "所属考试", prop: "subject_cate_name" },
        { label: "订单总价", prop: "fee" },
        { label: "实付价格", prop: "fees", isMyself: true },
        { label: "收益类型", prop: "income_type" },
        { label: "推广者姓名", prop: "promoter_fullname" },
        { label: "推广提成比例", prop: "tc_per" },
        { label: "老师/员工提成", prop: "tc_money" },
        {
          label: "机构收益（销售价-成本价：含提成部分）",
          prop: "group_tc_money",
        },
        { label: "订单状态", prop: "payStatus" },
        { label: "支付方式", prop: "cooperation_type" },
        { label: "实际支付时间", prop: "pay_at" },
        { label: "订单创建时间", prop: "created_at" },
        // { label: "操作", prop: "operation" },
      ],
      kamilColumns: [
        //卡密订单
        { label: "订单号", prop: "order_no" },
        { label: "学员账号", prop: "user_no" },
        { label: "学员姓名", prop: "realname" },
        { label: "学员手机号", prop: "mobile" },
        { label: "开通人（机构账号登录）", prop: "pm_user_id" },
        { label: "商品类型", prop: "goods_type_name" },
        { label: "商品名称", prop: "good_name" },
        { label: "商品ID", prop: "good_id" },
        { label: "所属考试", prop: "subject_cate_name" },
        { label: "订单总价", prop: "fee" },
        { label: "实付价格", prop: "fees", isMyself: true },
        { label: "订单状态", prop: "order_status" },
        { label: "支付状态", prop: "pay_type_name" },
        { label: "开卡状态", prop: "card_status_name" },
        { label: "实际支付时间", prop: "pay_at" },
        { label: "订单创建时间", prop: "created_at" },
        // { label: "操作", prop: "operation" },
      ],
      upgradeForm: {
        order_id: '',
        user_id: '',
        goods: [],
        selectGoods: '',
      }, // 要升级的商品数据
      role: "", // 当前角色
      is_study_card: 0,
      tableLoading: false, // 列表加载状态
      allSelectedStatus: false,
      selectableShow: false,
      subjectOptions: [],
      tongjiData:{}, 
      subjectAllOptions:[],
      firstTime: false, 
      dataReportData: {},
      trendType: '1',
      timeType: '1',
      xAxisData: [],
      seriesData: [],
      timeFrame: [],
      timeChange: 4,
      trendTypeOptions:[
        {value: 1, label: '正确率'},
        {value: 2, label: '答题数'},
        {value: 3, label: '考试得分'},
      ]
    };
  },
  computed: {
    trendTypeMap() {
      return new Map(this.trendTypeOptions.map(item => [item.value, item.label]))
    }, 
  },
  watch: {},
  created() {
    this.getMe();
    this.getTobHideMenu();
    this.getTobOpenExams();
    if (this.$route.query.uid) { 
      this.uid = this.$route.query.uid
      this.getTobStudentsInfo()
      this.firstTime = true
      this.getTobStudentsDatas()
    } 
    // this.$nextTick(() => {
    //   this.initChart()  
    // })
  },
  mounted(){
  },
  methods: { 
    timeChangeClick() {
      this.timeFrame = [];
      this.queryInfo.pay_start_time = "";
      this.queryInfo.pay_end_time = "";
      this.queryInfo.created_start_time = "";
      this.queryInfo.created_end_time = "";
    },
    // 日期查询
    selectData(e) {
      if (e) {
        if (this.timeChange == 4) {
          this.queryInfo.pay_start_time = e[0];
          this.queryInfo.pay_end_time = e[1];
          this.queryInfo.created_start_time = "";
          this.queryInfo.created_end_time = "";
        } else {
          this.queryInfo.pay_start_time = "";
          this.queryInfo.pay_end_time = "";
          this.queryInfo.created_start_time = e[0];
          this.queryInfo.created_end_time = e[1];
        }
      } else {
        this.queryInfo.pay_start_time = "";
        this.queryInfo.pay_end_time = "";
        this.queryInfo.created_start_time = "";
        this.queryInfo.created_end_time = "";
      } 
      this.queryTable();
    },
    trendTypeChange(e){
      console.log("trendTypeChange", e)
      this.typeChange()
      // if(e=='1'){  
      //   this.xAxisData = []
      //   this.seriesData = []
      //   this.dataReportData.right_line.day.forEach(item=>{
      //     this.xAxisData.push(item.name)
      //     this.seriesData.push(item.percent)  
      //   }) 
      // }else if(e=='2'){
      //   this.xAxisData = []
      //   this.seriesData = []
      //   this.dataReportData.right_line.day.forEach(item=>{
      //     this.xAxisData.push(item.name)
      //     this.seriesData.push(item.percent)  
      //   }) 
      // }else if(e=='3'){
      //   this.dataReportData.right_line

      // } 
    }, 
    timeTypeChange(e){
      console.log("timeTypeChange", e)
      this.typeChange() 
    }, 
    typeChange(){
      console.log("typeChange", this.trendType, this.timeType)
      this.xAxisData = []
      this.seriesData = []
      if(this.trendType=='1' && this.timeType == '1'){
        this.dataReportData.right_line.day.forEach(item=>{
          this.xAxisData.push(item.name)
          this.seriesData.push(Number(item.percent)*100)  
        })  
      }else if(this.trendType=='1' && this.timeType == '2'){
        console.log('week',this.dataReportData.right_line.week) 
        this.dataReportData.right_line.week.forEach(item=>{
          this.xAxisData.push(item.name)
          this.seriesData.push(Number(item.percent)*100)  
        })  
      }else if(this.trendType=='2' && this.timeType == '1'){
        console.log('week',this.dataReportData.answer_num_line.day)
        this.dataReportData.answer_num_line.day.forEach(item=>{
          this.xAxisData.push(item.name)
          this.seriesData.push(item.percent)  
        })   
      }else if(this.trendType=='2' && this.timeType == '2'){
        console.log('week',this.dataReportData.answer_num_line.week)
        this.dataReportData.answer_num_line.week.forEach(item=>{
          this.xAxisData.push(item.name)
          this.seriesData.push(item.percent)  
        })    
      }else if(this.trendType=='3' && this.timeType == '1'){
        this.dataReportData.score_line.day.forEach(item=>{
          this.xAxisData.push(item.name)
          this.seriesData.push(item.percent)  
        })    
      }else if(this.trendType=='3' && this.timeType == '2'){
        console.log('week',this.dataReportData.score_line.week) 
        this.dataReportData.score_line.week.forEach(item=>{
          this.xAxisData.push(item.name)
          this.seriesData.push(item.percent)  
        })   
      } 
      this.initChart()
    },
    initChart() {  
      var chartDom = document.getElementById('myChart'); 
      var myChart = echarts.init(chartDom);  

      var trendTypeName = this.trendTypeMap.get(Number(this.trendType)) + '：'

      var that = this
      console.log("Data---", that.trendType, trendTypeName, that.xAxisData, that.seriesData)

      var yAxisFormatter = ''
      if(that.trendType=='1'){
        yAxisFormatter = '{value} %' 
      }else{
        yAxisFormatter = '{value}'
      }
      var tooltipFormatter = ''
      if(that.trendType=='1'){
        tooltipFormatter = trendTypeName + '{c}%'  
      }else{
        tooltipFormatter = trendTypeName + '{c}' 
      }


      const option = { 
        xAxis: {
          type: 'category',
          data: that.xAxisData
        },
        yAxis: {
          type: "value",
          axisLabel:{
            formatter: yAxisFormatter
          }
        },
        tooltip:{
          trigger: 'axis',
          formatter: tooltipFormatter
        },
        series: [
          {
            data: that.seriesData,
            type: 'line'
          }
        ]
      }  
      myChart.clear();
      option && myChart.setOption(option); 
    },
 
    handleClick(e) {
      console.log('handleClick', e);
      if(e == 'name_1'){
        this.type = 1
        this.getTobStudentsDatas()
      } else if(e == 'name_2') {
        this.type = 2 
        this.timeChangeClick()
        this.queryTable()
      } else if(e == 'name_3') {
        this.type = 3
        this.getTobStudentsDatas() 
      } else if(e == 'name_4') { 
        this.type = 4
        this.getTobStudentsDatas()
      } else if(e == 'name_5') { 
        this.type = 5
        this.getTobStudentsDatas()
      }
    },
    subjectChange(e){
      console.log("subjectChange", e)
      this.getTobStudentsDatas()
    },    
    payStatusChange(e){ 
      this.queryTable();
    },
    async getTobOpenExams() {
      const res = await goodsApi.getTobOpenExams(this.queryInfo);
      if (res.code == 200) {
        console.log("getTobOpenExams---", res.data);
        this.subject_cate_ids = [];
        this.subjectOptions = res.data.subject_cate_list;
        res.data.subject_cate_list.forEach((item) => {
          this.subject_cate_ids.push(item.key);
        });
      }
    },
    getTobHideMenu() {
      goodsApi.getTobHideMenu().then((res) => {
        if (res.code === 200) {
          this.is_study_card = res.data.is_study_card;
          console.log("is_study_card", res.data.is_study_card);
        }
      });
    },
    // 获取当前用户身份
    async getMe() {
      const res = await commonApi.tobMe();
      if (res.code === 200) {
        this.role = res.data.role;

        
        if(this.role == 'nstitutionalteacher'||this.role == 'salespersonr'){ 
          this.columns.forEach((item, index) => {
            if(item.prop=="fee"){
              this.columns.splice(index, 1)
            }
            if(item.prop=="fees"){
              this.columns.splice(index, 1) 
            } 
          })
        }
        console.log("角色", this.role);
      }
    },
    choiceGoods(e) { 
      this.selectedList = e;
    },
    // 列表数据
    async queryTable(_type) { 
      if(this.queryInfo.pay_status==0){
        this.selectableShow = true
      }else{
        this.selectableShow = false 
      }

      if (_type) {
        this.queryInfo.page = 1;
      }
      this.queryInfo.subject_cate_ids = this.subject_cate_ids.toString();
      let query = deepClone(this.queryInfo);
      query.order_type = this.orderType; 
      if (this.orderType == 2) {
        query = { ...query, ...this.queryInfoSelf };
        delete query.pm_user_id;
      }
      this.tableLoading = true;
      query.uid = this.uid
      query.type = this.type
      const res = await commonApi.getTobStudentsDatas(query);
      //  res);
      if (res.code == 200) {
        this.queryInfo.total = res.data.list.total;
        this.tableList = res.data.list.data;
        this.allInfo = res.data;
        this.userTypeList = Object.keys(res.data.use_type_list).map(
          (item, index, val) => {
            console.log("item", item);
            return {
              name: res.data.use_type_list[item],
              value: item,
            };
          }
        );
        console.log("this.userTypeList---", this.userTypeList);
        this.tableList.forEach((item, index) => {
          this.tableList[index].finType = item.type == 1 ? "支出" : "收入";
          let _noti = "";
          switch (item.good_type) {
            case 3:
              _noti = "做题会员卡";
              break;
            case 4:
              _noti = "购买课程";
              break;
            case 6:
              _noti = "学籍卡类型";
              break;
            case 10:
              _noti = "vip学员";
              break;
            case 11:
              _noti = "svip学员卡";
              break;
          }

          let _payStatus = "";

          if (item.is_study_card != 1) {
            switch (item.pay_status) {
              case 0:
                _payStatus = "已开通";
                break;
              case 1:
                _payStatus = "已扣款";
                break;
              case 2:
                _payStatus = "已取消";
                break;
              case 3:
                _payStatus = "已退款";
                break;
              case 4:
                _payStatus = "已扣款"; //退款中
                break;
              case 5:
                _payStatus = "已扣款"; //退款失败
                break;
              case 6:
                _payStatus = "未支付";
                break;
              case 7:
                _payStatus = "已支付";
                break;
            }
          } else {
            _payStatus = item.study_card_pay_status_name;
          }

          if (this.orderType == 2) {
            let _income_type = "";
            switch (item.income_type) {
              case 3:
                _income_type = "老师推广";
                break;
              case 2:
                _income_type = "员工推广";
                break;
              case 1:
                _income_type = "自推";
                break;
            }
            // 如果是自推
            if (item.income_type == 1) {
              this.tableList[index].tc_per = "-";
              this.tableList[index].tc_money = "-";
            } else {
              this.tableList[index].tc_per = item.tc_per + "%*销售价";
            }
            this.tableList[index].income_type = _income_type;
          }
          this.tableList[index].payStatus = _payStatus;
          this.tableList[index].fees = this.tableList[index].fee;
          this.tableList[index].finTransaction = _noti;
        });
        this.tableLoading = false;

        this.order_status_list = res.data.order_status_list;
        this.card_status_list = res.data.card_status_list;
 
        if (res.data.can_operate && this.can_operate_show) { 
          this.columns.push({ label: "操作", prop: "operation" })
          this.selfColumns.push({ label: "操作", prop: "operation" })
          this.kamilColumns.push({ label: "操作", prop: "operation" })
          this.can_operate_show = false
        }
        if(!res.data.can_view_amount){
          this.columns.forEach((item, index) => {
            if(item.prop=="fee"){
              this.columns.splice(index, 1)
            }
            if(item.prop=="fees"){
              this.columns.splice(index, 1) 
            }
          })
          this.selfColumns.forEach((item, index) => { 
            if(item.prop=="fee"){
              this.selfColumns.splice(index, 1)  
            }
            if(item.prop=="fees"){
              this.selfColumns.splice(index, 1)   
            }
          })
          this.kamilColumns.forEach((item, index) => {
            if(item.prop=="fee"){
              this.kamilColumns.splice(index, 1)  
            }
            if(item.prop=="fees"){
              this.kamilColumns.splice(index, 1)   
            } 
          }) 
        } 
        this.can_operate = res.data.can_operate;
        this.can_view_amount = res.data.can_view_amount;  
      }
    },
    // 订单类型改变
    orderTypeChange() {
      console.log("改变", this.orderType);

      this.allStatus = false
      this.allSelectedStatus = false
      this.selectedList = []
      // 类型切换就重置请求参数
      this.queryTable() 
    },
    // 分页
    handleSizeChange2(e) {
      //  e);
      this.queryInfo.limit = e;
      this.queryTable();
    },
    handleCurrentChange2(e) {
      this.allSelectedStatus = false
      this.queryInfo.page = e;
      this.queryTable();
    }, 
    getTobStudentsDatas(){ 
      const postData = this.searchFormObj
      postData.uid = this.uid
      postData.type = this.type
      if(this.activeName == 'name_1'){
        postData.subject_id = this.subject_ids
      }
      if(this.activeName == 'name_2'){
        postData.order_type = this.orderType;
      }
      commonApi.getTobStudentsDatas(postData).then((res) => {
        if (res.code === 200) { 
          this.tableData = res.data.list 
          this.total = res.data.total
          if(this.activeName == 'name_1'){
            this.tongjiData = res.data.tongji
            this.subjectAllOptions = res.data.subject_list 

            this.dataReportData = res.data.data_report
            // this.trendType=='1'
            // this.timeType == '1'
            // this.xAxisData = []
            // this.seriesData = []
            // res.data.data_report.right_line.day.forEach(item=>{
            //   this.xAxisData.push(item.name)
            //   this.seriesData.push(Number(item.percent)*100)  
            // })
            this.$forceUpdate()
 
            // setTimeout(() => {
            //   this.initChart() 
            // }, 2000);  

            if(this.firstTime){
              this.firstTime = false
              this.subject_ids = res.data.subject_list[0].subject_id
              this.getTobStudentsDatas() 
            }else{ 
              this.typeChange()
            }
          }  
          console.log("getTobStudentsDatas", res.data)
        } 
      })  
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`)
      this.searchFormObj.page = val
      this.getTobStudentsDatas()
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`)
      this.searchFormObj.limit = val
      this.searchFormObj.page = 1
      this.getTobStudentsDatas()
    }, 
    // 基本信息
    async getTobStudentsInfo() { 
      const res = await commonApi.getTobStudentsInfo({uid: this.uid});
      if (res.code == 200) { 
        this.studentsInfo = res.data 
        this.data_type_list = res.data.data_type_list
      } else {
        this.$message.error(res.message);
      }
    }, 
  },
};
</script>

<style lang="less" scoped>
.home {
  width: 100%;
  padding: 16px 32px 16px 16px;
  box-sizing: border-box; 
  overflow-x: initial;
  display: flex;
  justify-content: space-between;
  min-width: 1200px;
  background: #f7f8fb;
  .contLeft {
    width: 55%;
    min-width: 1020px;
    margin-right: 20px; 
    padding: 20px; 
    background-color: #fff;
     
  }
  .contRight {
    width: 42%;
    min-width: 360px; 
    display: block;
    padding: 20px; 
    background-color: #fff;
    
  }

  .page_box{
    text-align: center;
    margin-top: 20px;
  }

  .tongjiBox{
    display: flex;
    justify-content: flex-start;
    text-align: center;

    .tongjiItem{
      padding: 20px 0;
      min-width: 200px;
      border: 1px solid #ddd;
      margin-right: 20px;
    }
  }
  .subjectBox{
    padding-top: 20px;
  }
  .trendBox{
    .title{
      padding: 10px;
      margin: 10px 0 20px 0;
      background: #f7f8fb;
    }
    .cont{
      .radioBox{
        display: flex;
        justify-content:flex-start;
        align-items: center; 
      }
    }

    
    .chart_wrap {
        width: 100%;
      .broken_chart {
        width: 100%;
        height: 400px; 
      }
    }
  }
}
</style>
